import { render, staticRenderFns } from "./bnvdate.vue?vue&type=template&id=3d7333ef&"
import script from "./bnvdate.vue?vue&type=script&lang=js&"
export * from "./bnvdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports